import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import { Container } from './Container';
export const PageIntro = ({ title, intro }) => (_jsx(Intro, { children: _jsxs(Container, { children: [_jsx("h1", { children: title }), _jsx("p", { children: intro })] }) }));
const Intro = styled.header `
  padding: 2rem 0 1.8rem;
  background: ${({ theme }) => theme.colors.surface};

  h1 {
    max-width: 760px;
    margin: 0;
    color: ${({ theme }) => theme.colors.navy900};
    font-size: clamp(1.55rem, 2.3vw, 1.95rem);
    line-height: ${({ theme }) => theme.typography.lineHeights.heading};
  }

  p {
    max-width: 680px;
    margin: ${({ theme }) => theme.spacing.sm} 0 0;
    color: ${({ theme }) => theme.colors.muted};
    font-size: ${({ theme }) => theme.typography.sizes.sm};
  }
`;
